// Lazy-loads Calendly's widget script + CSS and opens the booking popup.
// Accepts either an embed code (full <script> snippet) or a raw URL — both
// are normalised to the underlying calendly.com link. Falls back to the
// platform-default URL when the input is empty.
const DEFAULT_CALENDLY_URL = "https://calendly.com/joost-vanderleij/neurogram";
const SCRIPT_SRC = "https://assets.calendly.com/assets/external/widget.js";
const CSS_HREF = "https://assets.calendly.com/assets/external/widget.css";

let loaderPromise = null;

function loadCalendly() {
  if (typeof window === "undefined") return Promise.resolve();
  if (window.Calendly) return Promise.resolve();
  if (loaderPromise) return loaderPromise;

  loaderPromise = new Promise((resolve, reject) => {
    if (!document.querySelector(`link[href="${CSS_HREF}"]`)) {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = CSS_HREF;
      document.head.appendChild(link);
    }
    const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => resolve());
      existing.addEventListener("error", reject);
      return;
    }
    const s = document.createElement("script");
    s.src = SCRIPT_SRC;
    s.async = true;
    s.onload = () => resolve();
    s.onerror = reject;
    document.body.appendChild(s);
  });
  return loaderPromise;
}

/** Extract the first https://calendly.com/... URL from `text`. The
 *  match preserves the full path + query string so event slugs and
 *  Calendly UI flags (e.g. ?hide_landing_page_details=1) survive. */
export function extractCalendlyUrl(text) {
  if (!text) return "";
  const m = String(text).match(
    /https?:\/\/(?:www\.)?calendly\.com\/[^\s'"<>]+/
  );
  return m ? m[0] : "";
}

/**
 * Open the Calendly booking popup. Pass either the coach's saved embed
 * code (preferred — preserves the exact URL/query params they pasted)
 * or a raw URL. Empty/missing values fall back to the platform default.
 */
export async function openCalendlyPopup(embedCodeOrUrl) {
  const extracted = extractCalendlyUrl(embedCodeOrUrl);
  const target = extracted || DEFAULT_CALENDLY_URL;
  try {
    await loadCalendly();
    if (window.Calendly && typeof window.Calendly.initPopupWidget === "function") {
      window.Calendly.initPopupWidget({ url: target });
    } else {
      window.open(target, "_blank", "noopener,noreferrer");
    }
  } catch (e) {
    window.open(target, "_blank", "noopener,noreferrer");
  }
}

export { DEFAULT_CALENDLY_URL };


